module.exports = __webpack_public_path__ + "src/assets/img/rco.2c46ca44.jpg";